export const APP_NAME = 'Hazel’s Games'

export * from './engine.js'
export * from './games.js'
export * from './rng.js'
export * from './avatars.js'
export * from './parentView.js'
export * from './skillLabels.js'
export * from './history.js'
export * from './milestones.js'
export * from './realtime.js'
export * from './rooms.js'
export * from './teddies.js'
export * from './words.js'

export * from './games/hangman.js'
export * from './games/maths.js'
export * from './games/maths-race.js'
export * from './games/memory.js'
export * from './games/round.js'
export * from './games/maths-adaptive.js'
export * from './games/maths-skills.js'
export * from './games/scramble.js'
export * from './games/riddles.js'
export * from './games/riddle-puzzle.js'
export * from './games/riddle-skills.js'
export * from './games/riddle-solve.js'
export * from './games/riddle-things.js'
export * from './games/riddle-words.js'
export * from './games/mastermind.js'
export * from './games/mastermind-score.js'
export * from './games/mastermind-skills.js'
export * from './games/mosaic.js'
export * from './games/mosaic-pictures.js'
export * from './games/mosaic-skills.js'
export * from './games/mosaic-solve.js'
export * from './games/sudoku.js'
export * from './games/sudoku-puzzle.js'
export * from './games/sudoku-skills.js'
export * from './games/sudoku-solve.js'
export * from './games/sudoku-techniques.js'
export * from './games/wordRound.js'
export * from './games/trolley.js'
export * from './games/trolley-questions.js'
export * from './games/trolley-shop.js'
